import { render, staticRenderFns } from "./LookupConfig.vue?vue&type=template&id=85b01cd0&scoped=true&"
import script from "./LookupConfig.vue?vue&type=script&lang=js&"
export * from "./LookupConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b01cd0",
  null
  
)

export default component.exports